export default function DiagonalCrossedCircleIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={Math.round((size * 17) / 16)}
        viewBox='0 0 16 17'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2.99972 13.4997C2.73938 13.2394 2.97603 12.5806 3.52831 12.0283L11.5282 4.02845C12.0805 3.47618 12.7392 3.23952 12.9996 3.49987C13.2599 3.76022 13.0233 4.41899 12.471 4.97126L4.47111 12.9711C3.91884 13.5234 3.26007 13.7601 2.99972 13.4997Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.00033 2.50033C4.68662 2.50033 2.00033 5.18662 2.00033 8.50033C2.00033 11.814 4.68662 14.5003 8.00033 14.5003C11.314 14.5003 14.0003 11.814 14.0003 8.50033C14.0003 5.18662 11.314 2.50033 8.00033 2.50033ZM0.666992 8.50033C0.666992 4.45024 3.95024 1.16699 8.00033 1.16699C12.0504 1.16699 15.3337 4.45024 15.3337 8.50033C15.3337 12.5504 12.0504 15.8337 8.00033 15.8337C3.95024 15.8337 0.666992 12.5504 0.666992 8.50033Z'
        />
      </svg>
    </span>
  );
}
